import React, { useEffect, useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import QRCode from "qrcode.react";
import moment from "moment";

function MembershipCard({ membershipDetails, setDownloadMem }) {
  const hiddenRef = useRef(null);

  const handlePrint = async () => {
    const input = hiddenRef.current;
    const canvas = await html2canvas(input, { scale: 2 }); // Higher scale for better quality
    const imgData = canvas.toDataURL("image/png");

    const pdfWidth = 600;
    const pdfHeight = 400;

    const pdf = new jsPDF({
      orientation: pdfWidth > pdfHeight ? "landscape" : "portrait", // Auto-detect orientation
      unit: "mm",
      format: [pdfWidth, pdfHeight], // Set PDF size to match image size
    });

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("ID_Card.pdf");
  };

  useEffect(() => {
    if (membershipDetails) {
      document.getElementById("download_membership_card")?.click();
      setDownloadMem(null);
    }
  }, [membershipDetails]);

  return (
    <div
      className=""
      ref={hiddenRef}
      style={{ position: "absolute", left: "-9999px" }}
    >
      <button
        onClick={handlePrint}
        id="download_membership_card"
        hidden
      ></button>
      <div className="member-card">
        <div className="orange-bar">
          <div>
            <p>M</p>
            <p>E</p>
            <p>M</p>
            <p>B</p>
            <p>E</p>
            <p>R</p>
          </div>
        </div>
        <div className="card-content">
          <div className="row">
            <div
              className="col-md-8"
              style={{ textAlign: "left", lineHeight: "1.8" }}
            >
              <div className="logo mb-3">
                <img src="assets/img/flower-logo.svg" alt="Zenosure Logo" />
              </div>
              <p>
                <strong>Name:</strong> {membershipDetails?.first_name}{" "}{membershipDetails?.middle_name}{" "}
                {membershipDetails?.last_name}
              </p>
              <p>
                <strong>Member ID #:</strong>{" "}
                {membershipDetails?.application_no}
              </p>
              <p>
                <strong>DOB:</strong>{" "}
                {moment(membershipDetails?.dob).format("DD-MM-YYYY") || "N/A"}
              </p>
              {/* <p>
                <strong>Contact Zenosure #:</strong>{" "}
                1234567890
              </p>
              <p>
                <strong>WhatsApp #:</strong>{" "}
                {
                  1234567890 || "N/A"
                }
              </p> */}
              <p>
                <strong>Plan Expired on:</strong>{" "}
                {moment(membershipDetails?.end_date).format("DD-MM-YYYY") ||
                  "N/A"}
              </p>
            </div>
            <div className="col-md-4 qr-section">
              {/* QR Code */}
              <div className="qr-code mb-4">
                <QRCode
                  value={`https://zenosure.com/checkMembership?membershipid=${membershipDetails?.application_no}`}
                  size={120}
                />
              </div>
              <div className="help-desk">
                <img
                  src={
                    membershipDetails?.kyc_details?.user_image_base64 ||
                    "https://api.zenosure.com/storage/fixed_images/user.jpg"
                  }
                  alt="User avatar"
                  style={{
                    width: "120px",
                    height: "120px",
                  }}
                />
              </div>
            </div>
          </div>
          <hr />
          <div
            className="help-desk"
            style={{ textAlign: "left", lineHeight: "1.8" }}
          >
            <p>
              <b>*</b>{" "}
              <small>
                Please contact us before you check in with our partners.
              </small>
            </p>
            <p>
              <b>*</b>{" "}
              <small>
                Please ensure you quote Zenosure as the referrer and your bills
                reflect.
              </small>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MembershipCard;
